
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative py-16 sm:py-20 lg:py-24 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/b76aa3acbcc6efeefbe5ab7ab006a959.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-orange-900/95 via-orange-800/90 to-orange-900/95"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full mb-6 sm:mb-8">
            <i className="ri-time-fill text-lg sm:text-xl"></i>
            <span className="text-sm sm:text-base font-semibold whitespace-nowrap">24/7 Emergency Service Available</span>
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 leading-tight font-['Playfair_Display'] px-4">
            Get Your Free Estimate Today
          </h2>
          
          <p className="text-lg sm:text-xl text-white/95 mb-8 sm:mb-10 leading-relaxed px-4">
            Expert collision repair and auto body services in Brooklyn. We work with all insurance companies and offer same-day service. Call now or request your free estimate online.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8 sm:mb-10 px-4">
            <a
              href="tel:+16319337887"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-white text-orange-600 hover:bg-gray-100 px-8 sm:px-10 py-4 sm:py-5 rounded-full text-lg sm:text-xl font-bold transition-all hover:scale-105 shadow-2xl whitespace-nowrap"
            >
              <i className="ri-phone-fill text-xl sm:text-2xl"></i>
              Call: (631) 933-7887
            </a>
            <Link
              to="/contact"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-orange-600 text-white hover:bg-orange-700 px-8 sm:px-10 py-4 sm:py-5 rounded-full text-lg sm:text-xl font-bold transition-all hover:scale-105 shadow-2xl whitespace-nowrap"
            >
              Get Free Estimate
              <i className="ri-arrow-right-line text-xl sm:text-2xl"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 px-4">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8 border border-white/20">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
                <i className="ri-shield-check-fill text-3xl sm:text-4xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-2">30+ Years</h3>
              <p className="text-sm sm:text-base text-white/90">Expert Experience</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8 border border-white/20">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
                <i className="ri-file-list-3-fill text-3xl sm:text-4xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-2">All Insurance</h3>
              <p className="text-sm sm:text-base text-white/90">Companies Accepted</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8 border border-white/20">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-4">
                <i className="ri-customer-service-2-fill text-3xl sm:text-4xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-2">24/7 Support</h3>
              <p className="text-sm sm:text-base text-white/90">Emergency Towing</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
